module.exports = __webpack_public_path__ + "img/pipes.1e15ed6c.png";